import { PropertySubCategoryGQL } from "./External";
function createEnumObject<T extends string>(o: { [P in T]: P }) {
  return o;
}

export const PropertySubcategory = createEnumObject<PropertySubCategoryGQL>({
  Detached: "Detached",
  Flat: "Flat",
  Healthcare: "Healthcare",
  High_Street_Retail: "High_Street_Retail",
  Hotel: "Hotel",
  Leisure: "Leisure",
  Manufacturing: "Manufacturing",
  Other: "Other",
  Semi_Detached: "Semi_Detached",
  Speciality: "Speciality",
  Storage_and_Distribution: "Storage_and_Distribution",
  Terraced: "Terraced",
  Warehouse: "Warehouse",
});
